import { render, staticRenderFns } from "./SalesOrderItemsCard.vue?vue&type=template&id=6105bbf2&scoped=true&"
import script from "./SalesOrderItemsCard.vue?vue&type=script&lang=ts&"
export * from "./SalesOrderItemsCard.vue?vue&type=script&lang=ts&"
import style0 from "./SalesOrderItemsCard.vue?vue&type=style&index=0&id=6105bbf2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6105bbf2",
  null
  
)

export default component.exports